module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ltQBC"))).then(() => parcelRequire('hEqeo'));